import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: []
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    enqueueSnackbar: (state, action) => {
      const key = action.payload.options && action.payload.options.key;

      state.notifications = [
        ...state.notifications,
        {
          ...action.payload,
          key: key || new Date().getTime() + Math.random()
        }
      ]
    },
    closeSnackbar: (state, action) => {
      state.notifications = state.notifications.map(notification => (
        (action.dismissAll || notification.key === action.key)
          ? { ...notification, dismissed: true }
          : { ...notification }
      ));
    },
    removeSnackbar: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.key !== action.payload,
      );
    }
  },
  extraReducers: {
  }
});

export const { enqueueSnackbar, closeSnackbar, removeSnackbar } = snackbarSlice.actions;

export const selectNotifications = state => state.snackbar.notifications;

export default snackbarSlice.reducer;
